<div class="row">
    <div class="col-12 col-md-3">
        <div class="card rounded-0" >
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Game</h3>
                    <div class="mb-3">
                        <label for="title" class="form-label">Game Title <em>*</em></label>
                        <input type="text" class="form-control" id="title" name="title" #title="ngModel" [(ngModel)]="data.title" required autocomplete="off">
                        <div *ngIf="f.submitted && title.invalid" class="invalid-feedback">
                            <div *ngIf="title.errors.required">Game Title is required</div>
                        </div>
                    </div>
                    <div class="mb-3" *ngIf="permission.game_integration">
                        <label for="game_method" class="form-label">Game Method <em>*</em></label>
                        <select class="form-control" name="game_method" #game_method="ngModel" [(ngModel)]="data.game_method" required>
                            <option [value]="'normal'">Normal</option>
                            <option [value]="'child'">Child</option>
                        </select>
                    </div>

                   
                    <div class="mb-3" *ngIf="permission.game_integration && data.game_method == 'normal'">
                        <label for="provider" class="form-label">API Provider <em>*</em></label>
                        <select class="form-control" name="provider" #provider="ngModel" [(ngModel)]="data.integration_id" required (change)="checkIfCurrentProviderHaveCategory()">
                            <option [value]="0">No</option>
                            <option [value]="provider.id" *ngFor="let provider of providers">{{provider.name}}</option>
                        </select>
                        <p class="mt-2" style="font-size:10px; line-height: 16px">Select "NO" for manual games. For API linkage, You are required to obtain API credential and setup the API setting from sidebar menu "SETTING" > "INTEGRATION" before you can link to games.</p>
                    </div>
                    <div class="mb-3" *ngIf="permission.game_integration && data.game_method == 'child'">
                        <label for="parent_id" class="form-label">Same to <em>*</em></label>
                        <select class="form-control" name="parent_id" #parent_id="ngModel" [(ngModel)]="data.parent_id" required (change)="checkIfCurrentProviderHaveCategoryParent()">
                            <option [value]="game.id" *ngFor="let game of games">{{game.title}}</option>
                        </select>
                        <p class="mt-2" style="font-size:10px; line-height: 16px">Select "NO" for manual games. For API linkage, You are required to obtain API credential and setup the API setting from sidebar menu "SETTING" > "INTEGRATION" before you can link to games.</p>
                    </div>
                    <div class="mb-3" >
                        <label for="logo" class="form-label">Image</label>
                        <app-image-uploader [type]="'single'" #imageUploader (deleteEvent)="removeImage()" (uploadEvent)="upload($event)"></app-image-uploader>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="category_id" class="form-label">Category <em>*</em></label>
                                <select class="form-control" id="category_id" name="category_id" [(ngModel)]="data.category_id">
                                    <option [value]="t.id" *ngFor="let t of categories">{{t.title}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="provider_categories.length > 0">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="provider_category_id" class="form-label">Provider Category <em>*</em></label>
                                <select class="form-control" id="provider_category_id" name="provider_category_id" [(ngModel)]="data.provider_category_id">
                                    <option [value]="t.type" *ngFor="let t of provider_categories">{{t.title}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    

                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="instruction" class="form-label">Game Play Instruction</label>
                        <textarea rows="10" id="instruction" class="form-control" name="instruction" #instruction="ngModel" [(ngModel)]="data.instruction" ></textarea>
                    </div>
                    <div class="mb-3">
                        <label for="instruction_iframe" class="form-label">Game Play Instruction <small>(with iframe)</small></label>
                        <textarea rows="10" id="instruction_iframe" class="form-control" name="instruction_iframe" #instruction_iframe="ngModel" [(ngModel)]="data.instruction_iframe" ></textarea>
                    </div>

                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
    </div>
</div>
